import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Box, Button, Typography} from 'views/components';
import {AddCircleOutlineOutlined} from 'views/icons';
import {Translate, MarkdownViewer, HoverToolBox} from 'views/module';

const DescriptionBox = (props) => {
  const [toolbar, setToolbar] = React.useState(false);

  const {
    clientData,
    setIsEditing,
  } = props;

  const description = clientData?.description?.blob;

  const anchorRef = React.useRef();

  const onMouseOver = () => {
    setToolbar(true);
  };

  const onMouseLeave = () => {
    setToolbar(false);
  };

  return (
    <Box
      ref={anchorRef}
      onMouseEnter={onMouseOver}
      onMouseLeave={onMouseLeave}
      sx={{
        'py': 1,
        '&:hover': {
          backgroundColor: 'background.highlighted', // Background color on hover
        },
      }}
    >
      <Stack >
        <Typography variant="subtitle1" sx={{fontWeight: 500}}>
          <Translate expression="client.ClientDetail.Correspondance.Header.Description" />
        </Typography>
        {
          (!Boolean(description)) &&
          <Button
            variant='text'
            startIcon={<AddCircleOutlineOutlined/>}
            onClick={() => setIsEditing(true)}
            sx={{
              'textTransform': 'none',
              'width': '400px',
              'justifyContent': 'flex-start',
              'textAlign': 'left',
              'backgroundColor': 'transparent',
              '&:hover': {
                backgroundColor: 'transparent',
              },
            }}
          >
            <Translate expression="generic.ClickToEditDescription" />
          </Button>
        }
        <MarkdownViewer
          value={description}
          truncate
          truncateLine={8}
        />
        <HoverToolBox
          toolBar={toolbar}
          anchorEl={anchorRef.current}
          onClickEdit={() => setIsEditing(true)}
          copiedText={description}
          hideTool={{
            emoji: true,
            copy: !description,
            delete: true,
          }}
        />
      </Stack>
    </Box>
  );
};
DescriptionBox.propTypes = {
  clientData: PropTypes.object.isRequired,
  setIsEditing: PropTypes.func.isRequired,
};

export default React.memo(DescriptionBox);
